<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="mt-16 d-flex align-center justify-center">
          <v-img
            style="cursor:pointer"
            @click="onClickLogo"
            max-height="150"
            max-width="250"
            src="@/assets/img/logo.svg"
          ></v-img>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" lg="12" class="login-part d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                <v-tabs grow v-model="loginTabs" class="my-16" light>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab :href="`#tab-login`">
                    Восстановление пароля
                  </v-tab>
                  <v-tab-item :value="'tab-login'" >
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">

                          <v-col>
                            <p class="login-slogan display-2 text-center font-weight-medium mt-10">Восстановление пароля</p>
                            <p class="login-slogan display-1 text-center font-weight-medium mb-10"></p>
                          </v-col>

                          <v-form ref="form" lazy-validation v-model="formValid">
                            <v-col>
                                <v-text-field
                                    light
                                    id="email"
                                    ref="email"
                                    v-model="email"
                                    :rules="[
                                        v => !!v || 'Поле обязательно для заполнения',
                                        v => /.+@.+/.test(v) || 'Укажите дейсвительный email',
                                        // v => v.toLowerCase() === this.email
                                    ]"
                                    value=""
                                    label="Email"
                                    placeholder="Email"
                                    persistent-placeholder
                                    outlined
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-row>
                                <v-col class="d-flex justify-space-between">
                                    <v-btn
                                        light
                                        large
                                        block
                                        color="success"
                                        @click="back">
                                        Назад
                                    </v-btn>
                                </v-col>
                                <v-col class="d-flex justify-space-between">
                                    <v-btn
                                        light
                                        large
                                        block
                                        :disabled="!formValid"
                                        color="primary"
                                        @click="forgotPassword">
                                        Отправить
                                    </v-btn>
                                </v-col>
                            </v-row>
                          </v-form>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-tab-item>

                </v-tabs>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-footer>
                <div class="primary--text">© {{new Date().getFullYear()}} ООО "ЖКХ Онлайн" все права защищены</div>
              </v-footer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <notification/>
  </v-app>
</template>

<script>
import Notification from '@/app/components/Notification';
import axios from '@/plugins/axios';
import { mapActions } from 'vuex';
export default {
  name: 'ForgotPassword',
  components: {Notification},
  props:{
    initEmail: { 
      type: String,
      default: '',
      required: false
    },
  },
  data() {
    return {
        loginTabs: '',
        formValid: true,
        email: '',
        emailRules: [
            v => !!v || 'Поле обязательно для заполнения',
            v => /.+@.+/.test(v) || 'Укажите дейсвительный email',
            // v => v.toLowerCase() === this.email
        ],
    }
  },
  methods: {
    ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
    onClickLogo(){
      window.location.href = '/';
    },
    back(){
      this.$router.push({name: 'Login'});
    },
    showSuccessMessage(message){
      this.SHOW_SUCCESS(message);
    },
    showErrorMessage(message){
      this.SHOW_ERROR({message, timeout: 10000});
    },
    async forgotPassword(){
        const isValid = this.$refs.form.validate();
        if(!isValid){
            return;
        }
        try{
            let result = await axios.post("forgot-password", {email: this.email}, {silence401: true})
            this.showSuccessMessage(result.data.message);
            setTimeout(() => this.back(), 3000);
        }catch(err){
            let errorMessage = 'Произошла ошибка';
            if(err.response.data && err.response.data.error){
                errorMessage = err.response.data.error;
            }
            if(err.response.status === 429){
              errorMessage = 'Превышено число повторных запросов на восстановление пароля. Проверьте ваши почтовые сообщения по восстановлению пароля или повторите запрос позже';
            }
            this.showErrorMessage(errorMessage);
        }
    },
  },
  created() {
      if(this.$route.params.email){
        this.email = this.$route.params.email;
      }else{
        this.email = this.initEmail;
      }
  },
}

</script>